<template>
  <settings-modal class="payment-settle-modal">
    <template slot="heading">Settle payment</template>

    <template>
      <v-text-field
        v-if="showReferenceNumber"
        v-model="form.referenceNumber"
        class="t-reference-number-field mb-2"
        autocomplete="off"
        :hint="isFieldRequired('referenceNumber') ? 'Required field' : undefined"
        :persistent-hint="isFieldRequired('referenceNumber')"
        label="Reference"
        :error-messages="getValidationErrorMessage('referenceNumber')"
      />

      <date-picker
        v-model="form.settlementDate"
        class="t-settlement-date-field"
        label="Settlement date"
        prepend-icon="event"
        hint="Required field"
        persistent-hint
        :allowed-dates="filterDate"
        :error-messages="getValidationErrorMessage('settlementDate')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        class="t-settle-button"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { getAvailableProcessingDates } from '@/utils/Transactions'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'

  // Models
  import { PAYMENT_CHANNELS } from '@/models/Payment'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import DatePicker from '@/components/ui/DatePicker'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentSettleModal',
    components: {
      SettingsModal,
      DatePicker,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: {
          referenceNumber: undefined,
          settlementDate: null
        },
        paymentSettleApiRequest: new ApiRequest(PaymentApi.settleByAccountant),
        paymentSettleSwiftReturnApiRequest: new ApiRequest(PaymentApi.settleSwiftReturnByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      requiredFields () {
        const requiredFields = [
          'settlementDate'
        ]

        if ([PAYMENT_CHANNELS.BLUOR_BANK].includes(this.payment.channel) && !this.payment.hasFinTag) {
          requiredFields.push('referenceNumber')
        }

        return requiredFields
      },
      allowedSettlementDates () {
        return getAvailableProcessingDates(this.payment?.channel)
      },
      payment () {
        return this.modal.data.payment
      },
      isFinTopUpReturn () {
        return this.payment.hasFinTag && this.payment.hasOutgoingReturnTag && (this.payment.isTopup || this.payment.isUnidentifiedTopup)
      },
      showReferenceNumber () {
        return !this.isFinTopUpReturn && (!this.payment.isChannelIncore || !this.payment.hasFinTag)
      },
      loading () {
        return this.paymentSettleApiRequest.loading
      },
      error () {
        return this.paymentSettleApiRequest.error
      }
    },
    created () {
      this.setFieldValue('settlementDate', this.allowedSettlementDates[0])
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.settlePayment()
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Payment has been successfully settled' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      settlePayment () {
        return !this.isFinTopUpReturn
          ? this.paymentSettleApiRequest.execute(this.payment.id, this.parsedFormInput)
          : this.paymentSettleSwiftReturnApiRequest.execute(this.payment.id, this.parsedFormInput)
      },
      filterDate (date) {
        return this.allowedSettlementDates.includes(date)
      }
    }
  }
</script>
